import { addStyles } from 'ethcss'
import { colors } from '../../../theme'

const editorAnimationSettings = {
    animationWrapper: {
        paddingBottom: 50,
    },
    useAnimation: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    optionWrapper: {
        marginTop: 20,
        marginBottom: 30,
    },
    option: {
        marginBottom: 10,
    },
    previewWrapper: {
        marginTop: 40,
    },
    previewLabel: {
        marginBottom: 7,
    },
    preview: {
        position: 'relative',
        width: 300,
        height: 169,
        borderRadius: 12,
        overflow: 'hidden',
        backgroundColor: 'var(--var-module-app-component-editor-style-backgroundContent, #494848)',
    },
    contentArea: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
    },
    content: {
        position: 'absolute',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    checkbox: {},
    rangeWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: '100%',
    },
    rangeIcon: {
        width: 24,
        height: 24,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
        overflow: 'hidden',
        '& svg': {
            display: 'block',
            maxWidth: 24,
            maxHeight: 24,
        },
    },
    range: {
        appearance: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        flex: 1,
        minWidth: 0,
        height: 6,
        margin: '5px 0',
        padding: 0,
        direction: 'rtl',
        borderRadius: 3,
        outline: 'none',
        cursor: 'pointer',
        '&::-webkit-slider-runnable-track': {
            width: '100%',
            height: 6,
            borderRadius: 3,
            background: 'transparent',
        },
        '&::-webkit-slider-thumb': {
            WebkitAppearance: 'none',
            appearance: 'none',
            width: 16,
            height: 16,
            marginTop: -5,
            borderRadius: '50%',
            backgroundColor: colors.blueAccent,
            border: `2px solid ${colors.white}`,
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.16)',
            cursor: 'pointer',
        },
        '&::-moz-range-track': {
            width: '100%',
            height: 6,
            borderRadius: 3,
            background: 'transparent',
            border: 'none',
        },
        '&::-moz-range-progress': {
            height: 6,
            borderRadius: 3,
            background: 'transparent',
        },
        '&::-moz-range-thumb': {
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: colors.blueAccent,
            border: `2px solid ${colors.white}`,
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.16)',
            cursor: 'pointer',
        },
    },
    rangeLabel: {
        marginBottom: 7,
    },
    applyForAll: {
        marginTop: 40,
    },
    applyForAllLabel: {
        marginBottom: 10,
    },
    multipleConfirmModal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(0,0,0,0.7)',
        zIndex: 10000,
    },
    multipleConfirmModalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        padding: 30,
        borderRadius: 10,
        maxWidth: 384,
        lineHeight: 1.3,
        textAlign: 'center',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20,
    },
    button: {
        margin: '0 10px',
    },
}

addStyles(editorAnimationSettings)
export default editorAnimationSettings
